import { type FC, type HTMLAttributes } from 'react';

import { safelyConvertDate } from '@craft/lib/dates';

import { AssignedProgramContentCard } from '@/src/components/organisms/AssignedProgramContentCard';
import { Pages } from '@/src/config/pages';

import { type SearchedAssignedActivity } from './useSearchQueryData';

type SearchBarOptionProps = {
  readonly option: SearchedAssignedActivity;
} & HTMLAttributes<HTMLLIElement>;

export const SearchBarOption: FC<SearchBarOptionProps> = ({
  option: { latestScore, status, timeSpentOnActivity, userIds, ...option },
}: SearchBarOptionProps) => {
  const dueDate = option.dueDate
    ? (safelyConvertDate(option.dueDate, { returnAs: 'Date', strict: false }) ?? undefined)
    : undefined;

  return (
    <AssignedProgramContentCard
      aria-label='go to assigned activity'
      description={option.description}
      href={Pages.constructPath('assigned-activity', { assignedActivityId: option.id })}
      id={option.id}
      name={option.name}
      slots={{
        leftSlot: { dueDate, score: latestScore, status, userIds },
        rightSlot: timeSpentOnActivity ?? undefined,
      }}
    />
  );
};
